import { useEffect, useState } from "react";
import NavbarPage from "../../component/Navbar/NavBar";
import Footer from "../../component/Footer/Footer";
import Hero from "./Hero";
import Why from "../../component/Why";
import Program from "../../component/Program";
import Scholarship from "../../component/Scholarship";
import Benefit from "../../component/Benefit";
import Galery from "../../component/Galery";

const Layout_1 = () => {
  const [navItems] = useState([
    { id: 1, idnm: "beranda", navheading: "Beranda" },
    { id: 2, idnm: "why", navheading: "Keunggulan" },
    { id: 3, idnm: "program", navheading: "Program Studi" },
    { id: 4, idnm: "scholarship", navheading: "Beasiswa" },
    { id: 5, idnm: "benefit", navheading: "Manfaat" },
    { id: 6, idnm: "galery", navheading: "Gallery" },
    { id: 7, idnm: "footer", navheading: "Kontak" },
  ]);

  const [navClass, setNavClass] = useState("");

  useEffect(() => {
    const scrollNavigation = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 80) {
        setNavClass("nav-sticky");
      } else {
        setNavClass("");
      }
    };

    window.addEventListener("scroll", scrollNavigation);

    return () => {
      window.removeEventListener("scroll", scrollNavigation);
    };
  }, []);

  return (
    <>
      <NavbarPage navItems={navItems} navClass={navClass} />
      <Hero />
      <Why />
      <Program />
      <Scholarship />
      <Benefit />
      <Galery />
      <Footer />
    </>
  );
};

export default Layout_1;